<template>
  <div v-if="show" class="list-box">
    <div class="propject_detail_info_close_btn" style="right:20px" @click="close"><i class="el-icon-error" /></div>
    <div class="serch-box">
      <h1 v-if="!findThirdPersonByName" style="margin:0">{{ companyName }}</h1>
      <h1 v-else style="margin:0">协会数据搜索</h1>
      <ul>
        <li>
          <span style="width:80px">姓名：</span>
          <el-input v-model="serch.姓名" size="mini" @keyup.enter.native="toserch"></el-input>
        </li>
        <li v-if="findThirdPersonByName">
          <span style="width:80px">公司：</span>
          <el-input v-model="serch.公司" size="mini" @keyup.enter.native="toserch"></el-input>
        </li>
        <li>
          <span style="width:80px">职能模块：</span>
          <el-select v-model="serch.职能模块" filterable multiple size="mini">
            <el-option v-for="item in categories" :key="item.名称" :value="item.名称"></el-option>
          </el-select>
        </li>
        <li>
          <span style="width:80px">人员变动：</span>
          <el-select v-model="serch.status" filterable multiple size="mini">
            <el-option v-for="item in status" :key="item.value" :value="item.value">
              <span class="simi-icon"><i :class="item.class"></i>{{ item.value }}</span>
            </el-option>
          </el-select>
        </li>
        <li>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="toserch">
            搜索
          </div>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="clearSerch">
            清空
          </div>
          <!-- <el-button type="primary" size="mini" style="margin-left: 10px;" @click="toserch">搜索</el-button>
          <el-button type="primary" size="mini" style="margin-left: 10px;" @click="clearSerch">清空</el-button> -->
        </li>
        <li>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 40px;" @click="showBulletin">
            情报
          </div>
          <!-- <el-button size="mini" style="margin-left: 40px;" @click="showBulletin">情报</el-button> -->
        </li>
      </ul>
      <div class="radish-act-grp">
        批量：
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="showEditDialog">修改字段内容</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="showCateDialog('添加')">添加职能模块</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="showCateDialog('删除')">删除职能模块</div>
      </div>
      <!-- <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 40px;" @click="mulUpdate">批量修改</div> -->
      <!-- <el-button size="mini" style="margin-left: 40px;" @click="mulUpdate">批量修改</el-button> -->
    </div>
    <div class="table-box">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="list"
        border
        :height="listheight"
        tooltip-eff0-ect="dark"
        size="mini"
        style="width: 100%"
        highlight-current-row
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.rid && editRowIndex !== scope.$index">
              <span class="drawer-link" @click="edit(scope.$index)">编辑</span>
            </div>
            <div v-else-if="scope.row.rid && editRowIndex === scope.$index">
              <span class="drawer-link" style="margin-right:5px" @click="cancelEdit">取消</span>
              <span class="drawer-link" @click="confirmEdit">保存</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="findThirdPersonByName" label="公司" prop="公司" width="120"> </el-table-column>
        <el-table-column
          v-for="item in tableHeads"
          :key="item.label"
          :prop="item.key"
          :label="item.label"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="editRowIndex !== scope.$index">
              <div v-if="item.key === '姓名'" class="name-cell">
                <span class="simi-icon" size="mini" @click="getSimi(scope.row)">
                  <i :class="simiClass(scope.row)"></i>
                </span>
                <span v-if="scope.row.rid" class="drawer-link" @click="showRadishDetail(scope.row)">{{
                  scope.row['姓名']
                }}</span>
                <span v-else class="company-pointer" @click="showBindRadish(scope.row, scope.$index)">{{
                  scope.row['姓名']
                }}</span>
                <span v-if="scope.row.rid && !scope.row.手机" style="line-height: 14px;" class="cc-icon">c</span>
              </div>
              <div v-else-if="tagKeys.includes(item.key)">
                <el-tag
                  v-for="(tag, index) in getTags(scope.row[item.key])"
                  :key="index + 2"
                  type="success"
                  size="mini"
                  style="text-align:center"
                >
                  {{ tag }}
                </el-tag>
              </div>
              <div v-else-if="btnKeys.includes(item.key)">
                <span
                  v-if="item.key === '部门详情' && scope.row.部门"
                  class="drawer-link"
                  @click="showDepartmentDetail(scope.row)"
                  >部门详情</span
                >
                <span v-if="item.key === '口碑打分' && scope.row.rid" class="drawer-link" @click="showScore(scope.row)"
                  >口碑打分</span
                >
                <span
                  v-if="item.key === '任职经历' && scope.row.rid"
                  :id="`任职经历${scope.row.rid}`"
                  class="drawer-link"
                  @click="showExp(scope.row)"
                  >查看（{{ getExpNum(scope.row) }}）</span
                >
              </div>
              <div v-else-if="item.key === '手机'">
                <el-tooltip class="item" effect="dark" :content="scope.row[item.key]" placement="top">
                  <span v-if="scope.row[item.key]" class="company-pointer">***</span>
                </el-tooltip>
              </div>
              <div v-else>
                <span class="company-pointer">{{ scope.row[item.key] }}</span>
              </div>
            </div>
            <div v-else>
              <!-- 编辑样式 -->
              <div v-if="inputKeys.includes(item.key)">
                <el-input v-model="editObj[item.key]" size="mini"></el-input>
              </div>
              <div v-else-if="btnKeys.includes(item.key)">
                <span v-if="item.key === '部门详情' && scope.row.部门" class="drawer-link" @click="alertMsg('部门详情')"
                  >部门详情</span
                >
                <span v-if="item.key === '口碑打分' && scope.row.rid" class="drawer-link" @click="showScore(scope.row)"
                  >口碑打分</span
                >
                <span
                  v-if="item.key === '任职经历' && scope.row.rid"
                  :id="`任职经历${scope.row.rid}`"
                  class="drawer-link"
                  @click="showExp(scope.row)"
                  >查看（{{ getExpNum(scope.row) }}）</span
                >
              </div>
              <div v-else>
                <el-select
                  v-if="objOptions.includes(item.key)"
                  v-model="editObj[item.key]"
                  :multiple="tagKeys.includes(item.key)"
                  filterable
                  size="mini"
                >
                  <el-option v-for="(v, k) in selectOption[item.key]" :key="v" :label="k" :value="v"> </el-option>
                </el-select>
                <el-select
                  v-else
                  v-model="editObj[item.key]"
                  :multiple="tagKeys.includes(item.key)"
                  filterable
                  size="mini"
                  @change="val => setSelectOption(val, item.key)"
                >
                  <el-option v-for="item in selectOption[item.key]" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="company-pagination"
        :current-page="page"
        :page-sizes="[20, 70, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog
      ref="serchRadishDialog"
      :could-insert="true"
      :sort="companyShortName"
      choose-btn-text="绑定"
      @choose="bindRadish"
    >
      <template slot="header">
        <div class="table-box">
          <table class="a-table" cellspacing="0">
            <tr>
              <th>姓名</th>
              <th>公司</th>
              <th>证书编号</th>
              <th>执业岗位</th>
              <th>学历</th>
              <th>个人ID</th>
              <th>性别</th>
            </tr>
            <tr>
              <td>{{ handleRow['姓名'] }}</td>
              <td>{{ handleRow['公司'] }}</td>
              <td>{{ handleRow['证书编号'] }}</td>
              <td>{{ handleRow['执业岗位'] }}</td>
              <td>{{ handleRow['学历'] }}</td>
              <td>{{ handleRow['个人ID'] }}</td>
              <td>{{ handleRow['性别'] }}</td>
            </tr>
            <tr>
              <th>执业类型</th>
              <th>证书取得日期</th>
              <th>证书有效截止日期</th>
            </tr>
            <tr>
              <td>{{ handleRow['执业类型'] }}</td>
              <td>{{ handleRow['证书取得日期'] }}</td>
              <td>{{ handleRow['证书有效截止日期'] }}</td>
            </tr>
          </table>

          <div class="simi-type">注册变更记录:</div>
          <table class="a-table" cellspacing="0">
            <tr>
              <th>公司</th>
              <th>执业岗位</th>
              <th>证书编号</th>
              <th>证书取得日期</th>
              <th>证书状态</th>
            </tr>
            <tr v-for="(his, key) in handleRow['注册变更记录']" :key="key">
              <td>{{ his['公司'] }}</td>
              <td>{{ his['执业岗位'] }}</td>
              <td>{{ his['证书编号'] }}</td>
              <td>{{ his['证书取得日期'] }}</td>
              <td>{{ his['证书状态'] }}</td>
            </tr>
          </table>
        </div>
      </template>
    </serch-radish-dialog>
    <!-- 部门备注dialog -->
    <el-dialog
      title="部门备注"
      :visible.sync="departmentDialogVisible"
      :close-on-click-modal="false"
      :modal="false"
      width="30%"
    >
      <el-input v-model="departmentRemark" type="textarea" :rows="2" resize="none" placeholder="请输入内容"> </el-input>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="departmentDialogVisible = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="updateDepartmentRemark">确 定</div>
        <!-- <el-button size="mini" @click="departmentDialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="updateDepartmentRemark">确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 任职经历漂浮窗 -->
    <RadishExperiencePopper ref="RadishExperiencePopper"></RadishExperiencePopper>
    <!-- 情报 -->
    <Bulletin ref="Bulletin" :company-name="companyShortName"></Bulletin>
    <!-- <MulEditDialog ref="mulEditDialog"
                   :thirdPerson="true"
                   @confirm="mulUpdateConfirm"></MulEditDialog> -->
    <editDialog ref="editDialog" :on-confirm="loadData"></editDialog>
    <cateDialog ref="cateDialog" :on-confirm="loadData"></cateDialog>
  </div>
</template>
<script>
import serchRadishDialog from '../../company/src/component/serchRadishDialog.vue'
import { Bulletin, RadishExperiencePopper } from '../../company'
import tableHeads from '../../radish/src/constant/table-heads'
import editDialog from '../../radish/src/dialog/edit-dialog'
import cateDialog from '../../radish/src/dialog/cate-dialog'

const { fieldsBasic } = require('../../radish/src/constant/fields-detail.js')

export default {
  components: { serchRadishDialog, Bulletin, RadishExperiencePopper, editDialog, cateDialog },
  // props: {
  //   companyName: { type: String, default: '' },
  // },
  data() {
    return {
      companyName: '',
      list: [],
      companyShortName: '',
      show: false,
      loading: false,
      dialogBindRadish: false,
      departmentDialogVisible: false,
      bindRadishKeywords: '',
      departmentRemark: '',
      editRowIndex: -1,
      tableHeads: [
        { label: '姓名', key: '姓名', width: '100' },
        { label: '部门', key: '部门', width: '100' },
        { label: '部门详情', key: '部门详情', width: '100' },
        { label: '组别', key: '组别', width: '100' },
        { label: '口碑打分', key: '口碑打分', width: '100' },
        { label: '职能模块', key: '职能模块', width: '140' },
        { label: '任职经历', key: '任职经历', width: '140' },
        { label: '细分职能', key: '细分职能', width: '100' },
        { label: '擅长方向', key: '擅长方向', width: '100' },
        { label: '地域', key: '地域', width: '100' },
        { label: '目前职位', key: '目前职位', width: '100' },
        { label: '职级', key: '职级', width: '100' },
        { label: '业绩', key: '业绩', width: '100' },
        { label: '长期意向', key: '长期意向', width: '100' },
        { label: '手机', key: '手机', width: '100' },
      ],
      inputKeys: ['姓名', '部门', '组别', '目前职位', '手机'],
      selectOption: {
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        地域: fieldsBasic.地域.options,
        职级: fieldsBasic.职级.options,
        业绩: fieldsBasic.业绩.options,
        长期意向: fieldsBasic.长期意向.options,
      },
      objOptions: ['职级', '长期意向'],
      tagKeys: ['职能模块', '细分职能', '擅长方向', '地域'],
      btnKeys: ['部门详情', '口碑打分', '任职经历'],
      query: {},
      serch: {
        姓名: '',
        职能模块: [],
        status: '',
      },
      status: [
        { value: '在职', class: 'el-icon-success icon-blue' },
        { value: '新入职', class: 'el-icon-warning icon-red' },
        { value: '离职', class: 'el-icon-error icon-grey' },
      ],
      status2value: { 在职: 2, 新入职: 3, 离职: 4 },
      handleDepartmentRadish: '',
      handleRowIndex: -1,
      listheight: '100px',
      page: 1,
      total: 0,
      pageSize: 100,
      editRowIndex: -1,
      editObj: {},
      handleRow: {},
      findThirdPersonByName: false,
      isAdmin: false,
      editDialogTableHeads: [],
      multipleSelection: [],
    }
  },
  computed: {
    categories() {
      return app.categories
    },
  },
  watch: {
    $route(to, from) {
      this.close()
    },
  },
  async mounted() {
    this.initHeight()
    if (!app.categories) {
      await app.getCats()
    }
    if (app.user && app.user.角色 && app.user.角色.includes('行政')) this.isAdmin = true
    this.selectOption.职能模块 = app.categories.map(catrgory => catrgory.名称)
    const str = app.user.SL权限 || ''
    this.canSeeTel = str.split(';')
    const editTypes = ['细分职能', '擅长方向', '地域', '职级', '业绩', '长期意向', '部门', '组别', '目前职位']
    this.editDialogTableHeads = tableHeads.data().tableHeads.filter(v => editTypes.includes(v.label))
  },
  methods: {
    isShowTel(category) {
      if (this.isAdmin) {
        return true
      } else {
        let flag = false
        if (Array.isArray(category)) {
          category.forEach(val => {
            if (this.canSeeTel.includes(val)) flag = true
          })
        } else {
          flag = true
        }
        return flag
      }
    },
    open(company) {
      this.show = true
      this.serch = {}
      this.companyName = company
      this.findThirdPersonByName = false
      this.getShortName()
      this.toserch()
    },
    initHeight() {
      this.$nextTick(() => {
        const serchDom = document.querySelector('.serch-box')
        const serchHeight = (serchDom && serchDom.offsetHeight) || 120
        this.listheight = `${window.innerHeight - (serchHeight + 60 + 32 + 6)}px`
      })
    },
    mulUpdate() {
      const arr = this.multipleSelection.filter(v => v.rid)
      if (arr.length === 0) this.$message('请选择有效行，仅可修改已绑定人选的数据')
      else this.$refs.mulEditDialog.open(this.multipleSelection)
    },
    mulUpdateConfirm(obj) {
      const { type } = obj
      const arr = this.multipleSelection.filter(v => v.rid)
      if (this.tagKeys.includes(type)) {
        const { category, insertValue, deleteValue } = obj
        const promiseArr = arr.map(row => {
          row.职能模块 = row.职能模块 || []
          row[type] = row[type] || []
          if (!row.职能模块.includes(category)) row.职能模块.push(category)
          if (deleteValue.length > 0) row[type] = row[type].filter(v => !deleteValue.includes(v))
          insertValue.forEach(v => {
            if (!row[type].includes(v)) row[type].push(v)
          })
          return app.service('radish').modifyById({
            _id: row.rid,
            data: { 职能模块: row.职能模块, [type]: row[type] },
          })
        })
        Promise.all(promiseArr)
      } else {
        const { data } = obj
        const promiseArr = arr.map(row => {
          row[type] = data
          return app.service('radish').modifyById({
            _id: row.rid,
            data: { [type]: row[type] },
          })
        })
        Promise.all(promiseArr)
      }
    },
    getTags(val) {
      if (typeof val === 'string' && val) return [val]
      else if (Array.isArray(val)) return val.filter(v => v)
      else return []
    },
    showBulletin() {
      this.$refs.Bulletin.open()
    },
    setSelectOption(arr, key) {
      if (key !== '职能模块') return
      let directionArr = []
      arr.forEach(val => {
        const o = app.categories.find(v => v.名称 === val)
        if (o) directionArr = directionArr.concat(o.擅长方向)
      })
      this.selectOption.擅长方向 = directionArr
      let secondArr = []
      arr.forEach(val => {
        const o = app.categories.find(v => v.名称 === val)
        if (o) secondArr = secondArr.concat(o.二级职能)
      })
      this.selectOption.细分职能 = secondArr
    },
    alertMsg(type) {
      if (type === '部门详情') {
        this.$message('非编辑状态才可以操作部门详情')
      }
    },
    edit(index) {
      this.editRowIndex = index
      const row = this.list[index]
      for (const key in row) {
        const val = typeof row[key] === 'object' ? JSON.parse(JSON.stringify(row[key])) : row[key]
        this.$set(this.editObj, key, val)
      }
      this.setSelectOption(this.editObj.职能模块, '职能模块')
    },
    cancelEdit() {
      this.editRowIndex = -1
      this.editObj = {}
    },
    async confirmEdit() {
      const keys = [
        '姓名',
        '部门',
        '组别',
        '职能模块',
        '细分职能',
        '擅长方向',
        '地域',
        '目前职位',
        '职级',
        '业绩',
        '长期意向',
        '手机',
      ]
      const option = {}
      const oldData = this.list[this.editRowIndex]
      const newData = this.editObj
      keys.forEach(key => {
        if (typeof newData[key] === 'object') {
          if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
            option[key] = newData[key]
          }
        } else if (newData[key] !== oldData[key]) option[key] = newData[key]
      })
      if (Object.keys(option).length > 0) {
        const res = await app.service('radish').modifyById({
          _id: oldData.rid,
          data: option,
        })
        if (res.status == 'success') {
          Object.keys(option).forEach(key => {
            oldData[key] = newData[key]
          })
          this.$message.success({ duration: 500, message: '修改成功' })
        } else this.$message.error(res.msg)
      }
      this.cancelEdit()
    },
    getExpNum(item) {
      const exp = item.任职经历
      return Array.isArray(exp) ? exp.length : '0'
    },
    async showExp(item) {
      const option = { radishId: item.rid, 任职经历: item.任职经历, 姓名: item.姓名 }
      this.$refs.RadishExperiencePopper.open(option)
    },
    showScore(row) {
      app.root.$refs.radishScore.open(row.rid)
    },
    simiClass(row) {
      if (row.status == 1) {
        return 'el-icon-question icon-lightred'
      } else if (row.status == 2) {
        return 'el-icon-success icon-blue'
      } else if (row.status == 3) {
        return 'el-icon-warning icon-red'
      } else if (row.status == 4) {
        return 'el-icon-error icon-grey'
      } else {
        return ''
      }
    },
    async getSimi(item) {
      if (!item.rid) {
        this.$message('该数据未与人选绑定')
        return
      }
      const copyObj = JSON.parse(JSON.stringify(item))
      copyObj._id = copyObj.rid
      copyObj.thirdId = copyObj.个人ID
      delete copyObj.rid
      delete copyObj.个人ID
      if (copyObj.status && copyObj.status > 0) {
        app.root.$refs.simiDialog.show(copyObj)
      }
    },
    async getShortName() {
      const result = await app.service('company').checkCompanyAlias(this.companyName)
      if (result.status === 200) this.companyShortName = result.data.简称
    },
    showRadishDetail(opts) {
      if (opts.rid) {
        window.open(`${window.frontend}/#/radish-detail-blank/${opts.rid}`, '_blank')
      } else this.$message('未与人选绑定')
    },
    async showDepartmentDetail(row) {
      const result = await window.app.service('company').getDepartmentDetail({
        公司: this.companyShortName,
        部门: row.部门,
      })
      this.departmentDialogVisible = true
      this.departmentRemark = (result.data && result.data.部门备注) || ''
      this.handleDepartmentRadish = row
    },
    async updateDepartmentRemark() {
      const row = this.handleDepartmentRadish
      const result = await window.app.service('company').updateDepartmentDetail({
        query: { 公司: this.companyShortName, 部门: row.部门 },
        data: { 部门备注: this.departmentRemark },
      })
      if (result.status == 200) {
        this.$message('保存成功')
        this.departmentDialogVisible = false
      }
    },
    async showBindRadish(row, index) {
      const defaultSerchRadishes = await this.getDefaultSerchData(row)
      this.$refs.serchRadishDialog.open(row, defaultSerchRadishes)
      this.handleRowIndex = index
      this.handleRow = row
    },
    async getDefaultSerchData(radish) {
      const res = await app.service('company').defaultSerchRadishes(radish.姓名)
      if (res.status === 'success') return res.data
      else return []
    },
    async bindRadish(radish) {
      const copyRadish = JSON.parse(JSON.stringify(radish))
      const row = this.list[this.handleRowIndex]
      row.rid = copyRadish._id
      delete copyRadish._id
      for (const key in copyRadish) {
        row[key] = copyRadish[key]
      }
      // 该人选绑定协会数据
      const res = await app.service('radish').bindThird({ rid: row.rid, third: { person: { 个人ID: row.个人ID } } })
      if (res.status !== 'success') {
        this.$message(res.msg)
      } else {
        this.list.splice(this.handleRowIndex, 1, row)
      }
    },
    async updatecompany(id, type) {
      const result = await window.app
        .service('company')
        .updateCompany({ company: { _id: id, 公司性质: type }, accessory: [] })
      if (result.status !== 200) {
        this.$message('修改失败，请稍后再试')
      }
    },
    sortChange(data) {
      if (data.prop === '排名' || data.prop === '签约时间') {
        this.sort[data.prop] = data.order === 'descending' ? -1 : 1
      }
      if (this.findThirdPersonByName) this.loadDataFromAllList()
      else this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      if (this.findThirdPersonByName) this.loadDataFromAllList()
      else this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      if (this.findThirdPersonByName) this.loadDataFromAllList()
      else this.loadData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    trim(val) {
      return val.replace(/(^\s*)|(\s*$)/g, '')
    },
    toserch() {
      this.page = 1
      const option = {}
      const { status2value } = this
      for (const key in this.serch) {
        const val = this.serch[key]
        if (typeof val === 'string') {
          if (val !== '') option[key] = this.trim(val)
        } else option[key] = val
      }
      if (option.status && option.status.length !== 0) {
        option.status = option.status.map(v => status2value[v])
      }
      this.query = option
      if (this.findThirdPersonByName) this.loadDataFromAllList()
      else this.loadData()
    },
    clearSerch() {
      for (const key in this.serch) {
        if (Array.isArray(this.serch[key])) this.serch[key] = []
        else this.serch[key] = ''
      }
      this.query = {}
      this.page = 1
      if (this.findThirdPersonByName) this.loadDataFromAllList()
      else this.loadData()
    },
    async loadData() {
      const query = Object.assign(
        { query: this.query },
        { companyName: this.companyName },
        {
          paginate: {
            page: this.page,
            pageSize: this.pageSize,
          },
        },
      )
      try {
        this.loading = true
        const { data, page, pageSize, total } = await window.app.service('company').getThirdPersonList(query)
        this.loading = false
        this.list = data
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
        this.findThirdPersonByName = false
      } catch (error) {
        this.$message(error.message)
      }
    },
    async loadDataFromAllList() {
      const query = Object.assign(
        { query: this.query },
        {
          paginate: {
            page: this.page,
            pageSize: this.pageSize,
          },
        },
      )
      try {
        this.loading = true
        const { data, page, pageSize, total } = await window.app.service('company').findThirdPersonByName(query)
        console.log({ data, page, pageSize, total })
        this.loading = false
        this.list = data
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
        this.findThirdPersonByName = true
      } catch (error) {
        this.$message(error.message)
      }
    },
    async serchThirdPerson(name) {
      this.show = true
      this.serch = { 姓名: name }
      this.findThirdPersonByName = true
      this.toserch()
    },
    close() {
      this.show = false
    },
    showEditDialog() {
      if (this.multipleSelection.length === 0) return this.$message('请勾选人员')
      const arr = this.multipleSelection.filter(v => v.rid)
      const rows = arr.map(v => {
        const copyObj = JSON.parse(JSON.stringify(v))
        copyObj._id = v.rid
        copyObj.公司 = this.companyName
        delete copyObj.rid
        return copyObj
      })
      this.$refs.editDialog.show(this.editDialogTableHeads, rows)
    },
    showCateDialog(type) {
      if (this.multipleSelection.length === 0) return this.$message('请勾选人员')
      const arr = this.multipleSelection.filter(v => v.rid)
      const ids = arr.map(v => v.rid)

      if (ids.length === 0) return this.$message('请勾选已绑定人选')
      this.$refs.cateDialog.show(type, app.categories, ids)
    },
  },
}
</script>
<style scoped>
ul {
  padding: 0;
  overflow: hidden;
  list-style: none;
}
.serch-box {
  padding: 10px 20px 10px 20px;
  margin: 0 0 5px;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.serch-box span {
  display: inline-block;
}

.serch-box li {
  max-width: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  margin: 5px;
}

.serch-box li span {
  width: 60px;
}
.company-pointer {
  cursor: pointer;
}
.name-cell {
  position: relative;
  padding-left: 12px;
}
.list-box {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 30;
  padding-bottom: 10px;
  width: 100vw;
  background-color: #fff;
}
</style>
